// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"075f7e48","147":"50417853","348":"c221993c","737":"5342b541","787":"4b93ebb2","940":"bf1143df"}[chunkId] + ".chunk.js";
};